import { IAction, SET_FILTERS } from 'components/Screen';

import { FILTERS, OFFSET, TABLE_SETTINGS, initialState } from './constants';

export { SET_FILTERS } from 'components/Screen';

export const SET_TABLE_SETTINGS = 'SET_TABLE_SETTINGS';

export default function screenReducer(state: any = {}, action: IAction) {
  switch (action.type) {
    case SET_FILTERS:
      return {
        ...state,
        [FILTERS]: action.payload,
        [TABLE_SETTINGS]: {
          ...state[TABLE_SETTINGS],
          [OFFSET]: initialState[TABLE_SETTINGS][OFFSET],
        },
      };
    case SET_TABLE_SETTINGS:
      return {
        ...state,
        [TABLE_SETTINGS]: action.payload,
      };
    default:
      return state;
  }
}
